export default "__VITE_ASSET__BliUbaP___"